import { siteConfig } from "../siteConfig"

export const normalizeGaMeasurementId = (id: string): string  => {
  const trimmed = id.trim()
  if (!trimmed) {
    return ""
  }

  return trimmed.startsWith("G-") ? trimmed : `G-${trimmed}`
}

export const GA_MEASUREMENT_ID = normalizeGaMeasurementId(
  siteConfig.analytics.gaMeasurementId
)

export const isAnalyticsConfigured = (): boolean  => {
  return Boolean(GA_MEASUREMENT_ID)
}
